import { render } from "./TheHome.vue?vue&type=template&id=5460a56a"
import script from "./TheHome.vue?vue&type=script&lang=js"
export * from "./TheHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__